import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";

import { ANALYTICS } from "../constants";
import { CellComponentProps } from "../types";
import { showUnassignConfirmation } from "../../AssignRoleDrawer/UnassignConfirmation";
import { SettingsContext } from "../../../Context";

type IdpGroupRolesListItemActionsDropdownCellProps = CellComponentProps & {
  isLastRole: boolean;
};

const REFETCH_QUERIES_ON_UNASSIGN = ["UserGroupRoleBinding"];

const IdpGroupRolesListItemActionsDropdownCell = ({
  roleBinding,
  isLastRole,
}: IdpGroupRolesListItemActionsDropdownCellProps) => {
  const { activationStatus } = useTypedContext(SettingsContext);
  const roleUrl = `/settings/role/${roleBinding.roleID}`;

  return (
    <DropdownMenuEllipsis tooltip="Role actions">
      {!roleBinding.role.isSystem && (
        <DropdownMenuItem
          {...ANALYTICS}
          analyticsTitle="Preview permissions clicked"
          href={roleUrl}
        >
          Preview permissions
        </DropdownMenuItem>
      )}
      <DropdownMenuItem
        {...ANALYTICS}
        danger
        analyticsTitle="Unassign clicked"
        onAction={() =>
          showUnassignConfirmation({
            id: roleBinding.id,
            name: roleBinding.role.name,
            refetchQueries: REFETCH_QUERIES_ON_UNASSIGN,
            isLastRole,
            activationStatus,
          })
        }
      >
        Unassign
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default IdpGroupRolesListItemActionsDropdownCell;
